import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='vault' subtitle='object' mdxType="Item">
	An interface for configuring the display of vaulted payment methods.
	<Group mdxType="Group">
        <Item title='visible' subtitle='boolean' mdxType="Item">
	
Whether the vaulted payment methods are visible or not.
          <p>{`If this is not necessary for your use case, we recommend setting this to `}<inlineCode parentName="p">{`false`}</inlineCode>{` to skip the retrieval of the vault and speed up the loading of the checkout.`}</p>
          <p>{`Default value is `}<inlineCode parentName="p">{`true`}</inlineCode>{`.`}</p>
        </Item>
		<Item title='deletionDisabled' subtitle='boolean' mdxType="Item">
			Whether deleting a vaulted payment method is disabled or enabled.
		</Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      